import { keyframes, trigger, state, style, transition, animate } from '@angular/animations';

export const tabStateTrigger = trigger('tabState', [
    transition(':enter', [
        animate(300, keyframes([
            style({
                opacity: 1,
                transform: 'scale(1)'
            }),
            style({
                opacity: 1,
                transform: 'scale(1.05)'
            }),
            style({
                opacity: 1,
                transform: 'scale(1.2)'
            }),
            style({
            'text-decoration': 'underline',
            transform: 'scale(1.1)'
        })
        ]))
    ])
])

export const dropInStateTrigger = trigger('dropInState', [
    transition(':enter', [
    animate('700ms ease-out', keyframes([
      style({
        opacity: 0,
        transform: 'translateY(-100%)',
        offset: 0
      }),
      style({
        opacity:1,
        transform: 'translateY(15%)',
        offset: 0.4
      }),
      style({
        opacity:1,
        transform: 'translateY(0)',
        offset: 1
      })
    ]))
  ])
]);

export const slideInStateTrigger = trigger('slideInState', [
    transition(':enter', [
        style({
            transform: "translateX(-100%)",
            opacity: 0
        }),
        animate('500ms ease-out', keyframes([
            style({
            transform: "translateX(10%)",
            opacity: 1
        })
        ])
        )
    ]),
    transition(':leave', [
        style({
            transform: "translateX(0%)",
            opacity: 0
        }),
        animate('500ms ease-out', keyframes([
            style({
            transform: "translateX(-120%)",
            opacity: 1
        })
        ])
        )
    ])
    
]);


// WEBPACK FOOTER //
// ./src/app/shared/animations.ts